<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title text-uppercase m-0 c-body2 text-center">
        {{ $t("paymentInfoSecurityPolicy") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18 fw-600 ">{{ $t("policyObj.text91") }}</p>

        <p class="lh-18">
          {{ $t("policyObj.text92") }}
        </p>
        <p class="lh-18 fw-600 ">{{ $t("policyObj.text93") }}</p>

        <p class="lh-18">
          {{ $t("policyObj.text94") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text95") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text96") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text97") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text98") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text99") }}
        </p>
        <p class="lh-18">
          {{ $t("policyObj.text100") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text101") }}
        </p>
        <p style="font-style: italic;" class="lh-18 ">
          {{ $t("policyObj.text102") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text103") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-payment",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("privacyPolicy"),
        isShowHomeIcon: true,
        isShowMenu: true
      }
    };
  },
  created() {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
